module.exports = __webpack_public_path__ + "static/testimonial-e9fa27f959aa091dba487480cc5ee739.png";